module.exports = __webpack_public_path__ + "img/asx_base.d0d1e0e8.jpg";